<template>
  <v-card flat style="max-width: 100%" class="px-4">
    <v-card-title class="py-0" v-if="hide_header == false">
      <span style="font-size: 12px" class="primary--text"
        >Bank Accounts Amounts</span
      >
      <v-spacer></v-spacer>
      <bankToBankTransferForm />
    </v-card-title>

    <v-card-text :class="hide_header ? 'pt-3' : 'pt-0'">
      <v-layout row wrap justify-center>
        <v-flex
          class="text-xs-center pa-2"
          v-for="bank in bankInformations"
          :key="bank.name"
          v-show="bank.show_in_accounting_dashboard"
        >
          <v-card flat   style="border: 1px solid #ddd" class="pa-2 text-xs-center">
            <v-toolbar height="28" dense flat   color="transparent" class="text-xs-center"><v-spacer></v-spacer><v-icon size="12"  class="mt-1 pr-1">mdi-bank</v-icon>{{ bank.name }}<v-spacer></v-spacer></v-toolbar>
            <span class="caption" style="color: #333"></span>
            
            <v-label>
              {{
                inCurrencyFromId(
                  bank.currency_id,
                  bank.current_amount + bank.initial_amount
                )
              }}
            </v-label>
            <br />
            <h3 v-if="exchangeRates && exchangeRates.length">
              {{
                inCurrencyFromId(
                  exchangeRatesBaseCurrencyID,
                  (bank.current_amount + bank.initial_amount) *
                    (1 /
                      exchangeRates.find((exr) => {
                        return exr.id == bank.currency_id;
                      }).exchange_rate)
                )
              }}
            </h3>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          v-if="
            bankInformations.filter((bank) => {
              return bank.show_in_accounting_dashboard;
            }).length == 0
          "
        >
          <v-icon color="primary" class="pr-2" small>info</v-icon>You don't have
          any subsidiary banks configured to be displayed here
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import currency from "../../../mixins/currency.js";
import bankToBankTransferForm from "./bankToBankTransferForm";

export default {
  name: "bankInformationsCard",
  mixins: [currency],
  components: { bankToBankTransferForm },
  computed: {
    ...mapGetters("commonStore", ["bankInformations"]),
  },
  props: {
    hide_header: {
      type: Boolean,
      default: false,
      required: false,
    },
    exchangeRates: {
      type: Array,
      required: false,
    },
    exchangeRatesBaseCurrencyID: {
      type: String,
      default: "",
      required: false,
    },
  },
};
</script>
